import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'pencil/Typography';
import makeStyles from 'pencil/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(1),
  },
}));

const FieldTitle = (props) => {
  const { title, caption } = props;
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      <Typography>{title}</Typography>
      {caption && (
        <Typography variant="caption" color="textSecondary">
          {caption}
        </Typography>
      )}
    </div>
  );
};

FieldTitle.propTypes = {
  title: PropTypes.string.isRequired,
  caption: PropTypes.string,
};

FieldTitle.defaultProps = {
  caption: '',
};

export default FieldTitle;
